import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AddressModel extends Model {
  @attr('string') fullAddress!: string;
  @attr('string') street!: string;
  @attr('string') suite!: string;
  @attr('string') city!: string;
  @attr('string') state!: string;
  @attr('string') zipCode!: string;
  @attr('string') country!: string;
  @attr('string') countryCode?: string;
  @attr('number') latitude!: number;
  @attr('number') longitude!: number;

  @belongsTo('property', {
    inverse: 'address',
    async: false,
  })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    address: AddressModel;
  }
}
